<template>
  <div class="page">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <van-form @submit="onSubmit" :validate-trigger="$trigger" v-show="active1 == 0" class="van-form-without-tab">
      <van-cell-group title="原发票信息">
        <van-field readonly required clickable :value="form.fpactno" label="缴费号" placeholder="请选择缴费号" :rules="[{ required: true, message: '点击选择缴费号' }]">
          <template v-if="!$route.query.readonly" #button>
            <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
          </template>
        </van-field>
        <van-field readonly v-model="form.fname" label="用户名称" />
        <van-field readonly v-model="form.ffixaddr" label="用水地址" />
        <van-field readonly v-model="foldpayid" label="发票类型" />
        <van-field readonly v-model="form.foldinvoicename" label="发票抬头" />
        <van-field readonly v-model="form.foldbasebank" label="基本银行" />
        <van-field readonly v-model="form.foldbaseaccountno" label="银行账号" />
        <van-field readonly v-model="form.foldzzaddr" label="发票地址" />
        <van-field readonly v-model="form.foldzzpho" label="联系电话" />
      </van-cell-group>

      <van-cell-group title="新发票信息">
        <van-field v-model="form.finvoicename" label="发票抬头" placeholder="请输入发票抬头" :rules="[{ required: true, message: '请输入发票抬头' }]" />
        <van-field readonly clickable v-model="fpayid" label="发票类型" placeholder="请选择发票类型" @click="fpayidShow = true" :required="true" :rules="[{ required: true, message: '请选择发票类型'}]">
          <template #right-icon>
            <span class="iconfont iconxuanzesanjiao"></span>
          </template>
        </van-field>
        <van-popup v-model="fpayidShow" position="bottom">
          <van-picker title="发票类型" show-toolbar :default-index="fpayidIndex" :columns="fpayidColumns" @cancel="fpayidShow = false" @confirm="fpayidConfirm" />
        </van-popup>
        <van-field v-model="form.ftax" label="统一社会信用代码" placeholder="请输入统一社会信用代码" :rules="[{ required: true, message: '请输入统一社会信用代码' }]" />
        <van-field v-model="form.fbasebank" label="基本银行" placeholder="基本银行" :rules="[{ required: true,  message: '请输入基本银行' }]" />
        <van-field v-model="form.fbaseaccountno" label="银行账号" placeholder="请输入银行账号" :rules="[{ required: true, message: '请输入银行账号' }]" />
        <van-field v-model="form.fzzaddr" label="发票地址" placeholder="请输入发票地址" :rules="[{ required: true, message: '请输入发票地址' }]" />
        <van-field v-model="form.fzzpho" label="联系电话" placeholder="请输入联系电话" :rules="[{ required: true, pattern: $pattern, message: '请输入正确联系电话' }]" />
        <van-field v-model="form.fnetmark" rows="2" autosize label="申请说明" type="textarea" maxlength="500" placeholder="请输入备注" show-word-limit />
      </van-cell-group>

      <van-cell-group title="证件资料">
        <van-field required name="uploader" label="营业执照（统一社会信用代码）">
          <template #input>
            <van-uploader multiple :max-count="1" v-model="businessLicenseMst" :after-read="businessLicenseAfter" @delete="businessLicenseDelete" />
          </template>
        </van-field>
        <van-field name="uploader" label="其他资料">
          <template #input>
            <van-uploader multiple :max-count="3" v-model="unitotherMst" :after-read="unitotherAfter" @delete="unitotherDelete" />
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group title="申请人信息">
        <van-field required v-model="form.foper" label="姓名" placeholder="请输入姓名" :rules="[{required: true, message: '请输入姓名'}]" />
        <van-field required v-model="form.foperidno" label="身份证号" placeholder="请输入身份证号" :rules="[{pattern: $patternId, message: '请输入正确身份证号'}]" />
        <van-field v-model="form.fopertel" label="电话号码" placeholder="请输入电话号码" />
        <van-field required v-model="form.fopermobile" label="手机号码" placeholder="请输入手机号码" :rules="[{pattern: $pattern, message: '请输入正确手机号码'}]" />
        <van-field required v-show="modify" v-model="form.smscode" center clearable label="短信验证" placeholder="请输入短信验证" :rules="[{required: true, message: '请输入短信验证'}]">
          <template #button>
            <sms-btn :phone="form.fopermobile"></sms-btn>
          </template>
        </van-field>
      </van-cell-group>

      <yonghuxuzhi v-show="modify" @changeChecked="changeChecked" :typecode="typecode" :ftrantype="1"></yonghuxuzhi>

      <van-button block :disabled="!checked" type="info" native-type="submit" v-show="modify">
        提交
      </van-button>
    </van-form>

    <van-popup v-model="popShow" class="form-pop">
      <user-select-pop :userList="userList" :isquery="0" @onSelectClick="onSelectClick"></user-select-pop>
    </van-popup>
  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'
import UserSelectPop from '@/components/UserSelectPop.vue'

export default {
  name: 'MeterTransferForm',
  components: {
    smsBtn,
    UserSelectPop
  },
  data() {
    return {
      typecode: 210,
      active: 0,
      active1: 0,
      popShow: false,
      form: {
        ftrantype: 2,
        fsou: this.$comm.titleShow() ? 2 : 4,
        fpactno: '',
        fname: '',
        faddr: '',
        foldpayid: '',
        foldinvoicename: '',
        foldbasebank: '',
        foldbaseaccountno: '',
        foldzzaddr: '',
        foldzzpho: '',
        foldemail: '',
        foldtax: '',
        ftax: '',
        fpayid: '',
        finvoicename: '',
        fbasebank: '',
        fbaseaccountno: '',
        fzzaddr: '',
        fzzpho: '',
        femail: '',
        fnetmark: '',
        attach: [],
        fnetapplytype: 2,
        foper: '',
        foperidno: '',
        fopertel: '',
        fopermobile: '',
        smscode: ''
      },
      value: '',
      showPicker: false,
      userList: JSON.parse(localStorage.getItem('userList')),
      userInfo: {},
      isNameSame: false,
      foldpayid: '',
      fpayid: '', // 发票类型
      fpayidShow: false, // 发票类型显示
      fpayidColumns: [],
      fpayidIndex: 0,
      // 单位资料
      businessLicense: [], // 单位营业执照
      unitother: [], // 单位其他材料
      businessLicenseMst: [], // 单位营业执照
      unitotherMst: [], // 单位其他材料
      flag: this.$route.query.busstype ? false : true,
      modify: this.$route.query.modify ? (this.$route.query.modify === '1' || this.$route.query.modify === 1 ? false : true) : true,
      checked: false
    }
  },
  mounted() {
    this.getFpayType()
    if (!this.flag) {
      this.info()
    }
  },
  methods: {
    changeChecked(checked) {
      this.checked = checked
    },
    // 详情
    info() {
      this.$http.post(this.$api.getBussInfo, {
        busstype: this.$route.query.busstype,
        bussno: this.$route.query.bussno
      }).then(res => {
        if (res.code === '000') {
          this.form = res.data
          // 单位图片资料
          let result = this.$comm.serviceAttach(res.data)
          this.fpayidIndex = this.fpayidColumns.findIndex((profile) => profile.code === res.data.fpayid)
          this.fpayid = this.fpayidColumns[this.fpayidIndex].text
          // let fpayidIndex = this.fpayidColumns.findIndex((profile) => profile.code ===  res.data.foldpayid)
          // this.foldpayid = this.fpayidColumns[fpayidIndex].text
          this.businessLicense = result.businessLicense
          this.unitother = result.unitother
          this.businessLicenseMst = result.businessLicenseMst
          this.unitotherMst = result.unitotherMst
          console.log(this.active1)
          this.$clear()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onClick() {

    },
    onYonghuxuzhi() {

    },
    // 发票类型
    getFpayType() {
      this.fpayidColumns = []
      this.$http.post(this.$api.getBasedata, {
        "typeid": 8,
        "parentid": 0
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.fpayidColumns.push({
              text: el.fname,
              code: el.fid
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 发票类型选择
    fpayidConfirm(obj, index) {
      this.fpayid = obj.text
      this.form.fpayid = this.fpayidColumns[index].code
      console.log(this.form.fpayid)
      this.fpayidShow = false
    },
    // 营业执照
    businessLicenseAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.businessLicense.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    businessLicenseDelete(file, detail) {
      this.businessLicense.splice(detail.index, 1)
    },
    // 单位其他证明
    unitotherAfter(file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileuploadbase64, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.unitother.push({ url: res.data })
        } else {
          this.$toast('上传失败')
        }
      })
    },
    unitotherDelete(file, detail) {
      this.unitother.splice(detail.index, 1)
    },
    onSelectClick(user) {
      this.popShow = false
      this.form.fpactno = user.fpactno
      this.form.fuserno = user.fuserno
      this.form.fname = user.fname
      this.form.ffixaddr = user.ffixaddr
      this.form.foldwaterid = user.fwaterid
      this.form.foldwater = user.fwater
      this.form.foldpayid = user.fpayid
      let fpayidIndex = this.fpayidColumns.findIndex((profile) => profile.code === user.fpayid)
      this.foldpayid = this.fpayidColumns[fpayidIndex].text
      this.form.foldinvoicename = user.finvoicename
      this.form.foldbasebank = user.fbasebank
      this.form.foldbaseaccountno = user.fbaseaccountno
      this.form.foldzzaddr = user.fzzaddr
      this.form.foldzzpho = user.fzzpho
      this.form.foldemail = user.femail
    },
    choiceClick() {
      this.popShow = true
    },
    onSubmit() {
      this.form.attach = []
      if (this.businessLicense.length <= 0) {
        this.$toast('营业执照不能为空')
        return
      }
      this.form.attach.push({
        typeid: 3,
        url: this.businessLicense[0].url
      })
      if (this.form.length > 0) { // 单位其他材料
        let url = ''
        this.unitother.forEach(el => {
          if (url) {
            url = url + ',' + el.url
          } else {
            url = el.url
          }
        })
        this.form.attach.push({
          typeid: 13,
          url: url
        })
      }
      console.log(this.form)
      this.$http.post(this.$api.changepay, this.form).then(res => {
        if (res.code === '000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form {
  /deep/ .van-radio-group.van-radio-group--horizontal {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 33, 33, 1);

    .van-radio--horizontal {
      margin-right: 0;
      margin-left: 4px;

      .van-radio__label {
        margin-left: 2px;
      }
    }
  }

  .form-pop {
    width: 85%;
    height: 60%;
    border-radius: 4px;
    font-size: 12px;
  }
}
</style>